import { Component, ChangeDetectorRef } from '@angular/core';
import { Title, DomSanitizer } from '@angular/platform-browser';
import { AppService } from '../../../app.service';
import { TranslateService } from '../../../translate';
import { Router, ActivatedRoute } from '@angular/router';
import { Location, DatePipe } from '@angular/common';
import { NotificationsService } from 'angular2-notifications';
import { Subscription } from 'rxjs/Subscription';
import 'rxjs/add/operator/do';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/share';
import 'rxjs/add/operator/map';
import 'rxjs/add/observable/of';
import { SetupUndercarriageService } from '../setup-undercarriage.service';
import {
  CurrentSelection, SelectionLists,
  Customer, JobSite, Equipment, 
  SystemType, Side, ComponentSetup, Compart, SystemModelTemplate,
  ShoeSize, Make, ComponentGrouser, 
  SystemSetup, ResultMessage, InspectionUnsyncedVwMdl,
} from '../../../entities';
import { FormBuilder, FormGroup, Validators, FormControl } from '@angular/forms';

import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { Observable } from 'rxjs/Observable';
import { LoadingService } from '../../../shared/services/loading.service';
import moment from 'moment';
import { MomentDateAdapter } from '@angular/material-moment-adapter';
import { MY_FORMATS } from '../../rope-shovel/pages/rope-shovel-inspection/rope-shovel-inspection.component';
import { UCInspectionsService } from '../../uc-inspections/uc-inspections.service';
import { PreferencesService } from '../../preferences/preferences.service';
import { DataSource } from '@angular/cdk/table';
import { DateAdapter, MAT_DATE_LOCALE, MAT_DATE_FORMATS } from '@angular/material/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { GETPreferencesService } from '../../GET_NEW_UI/preferences/preferences.service';
import { SetupEquipmentService } from '../../setup-equipment/setup-equipment.service';
import { ConfirmationBoxComponent } from '../../../shared/confirmation-box/confirmation-box.component';
import { MatDialog } from '@angular/material/dialog';



enum SystemTypeSide {
  LeftChain = 1,
  RightChain = 2,
  LeftFrame = 3,
  RightFrame = 4
}

@Component({
  selector: 'setup-undercarriage-on-equipment',
  templateUrl: './setup-undercarriage-on-equipment.component.html',
  styleUrls: ['../setup-undercarriage.component.scss'],
  providers: [
    DatePipe,
    { provide: DateAdapter, useClass: MomentDateAdapter, deps: [MAT_DATE_LOCALE] },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
    { provide: MAT_DATE_LOCALE, useValue: 'en-au' },
  ],
})
export class SetupUndercarriageOnEquipment {
  translateSubscription: Subscription;
  userLanguage: string = "english";
  _currentSelection: CurrentSelection = new CurrentSelection();
  private skipChainSetup = false;
  isLinear = false;
  firstFormGroup: FormGroup;
  secondFormGroup: FormGroup;
  _dropDownLists: SelectionLists = new SelectionLists();
  _dropDownListsFiltered: SelectionLists = new SelectionLists();
  _leftChainSetup: SystemSetup = new SystemSetup();
  _rightChainSetup: SystemSetup = new SystemSetup();
  _leftFrameSetup: SystemSetup = new SystemSetup();
  _rightFrameSetup: SystemSetup = new SystemSetup();
  _currentAvailableTypes: Compart[] = [];
  _availableShoeSizes: ShoeSize[] = [];
  _availableCleanerholes: ShoeSize[] = [];

  _availableGrousers: ComponentGrouser[] = [{ Id: 0, Title: 'Unknown' }, { Id: 1, Title: 'Single Grouser' }, { Id: 2, Title: 'Double Grouser' }, { Id: 3, Title: 'Triple Grouser' }, { Id: 4, Title: 'Self Cleaning' }];
  _availableComponentMakes: Make[] = [];

  leftchainTableDatabase: ComponentTableDatabase | null;
  leftchainTableDataSource: ComponentDataSource | null;

  rightchainTableDatabase: ComponentTableDatabase | null;
  rightchainTableDataSource: ComponentDataSource | null;

  leftframeTableDatabase: ComponentTableDatabase | null;
  leftframeTableDataSource: ComponentDataSource | null;

  rightframeTableDatabase: ComponentTableDatabase | null;
  rightframeTableDataSource: ComponentDataSource | null;

  _selectedSide: Side = Side.Both;
  _selectedIndex: number = 0;
  _displayedColumns = ['delete', 'Component', 'Type', 'Pos', 'Brand', 'BudgetLife', 'HoursAtInstall', 'InstallCost', 'BushTurnedPercent', 'BushTurnedHours', 'MLink', 'JobNum', 'AssetNum', 'Size', 'Grouser', 'CleanerHoles'];
  _loading: number = 0;
  _lockEquipment: boolean = false;
  _routeId: number = 0;
  _unsyncedId: number = 0;
  _itIsUpdate: boolean = false;
  private _systemTemplate: SystemModelTemplate[] = [];
  routeSubscription: Subscription;
  bShowAllParts: boolean = true;
  sFilterBySameCompartIdL: string = "";
  sFilterBySameCompartIdR: string = "";
  sFilterBySameCompartIdB: string = "";
  leftChainSetupDateControl = new FormControl(moment());
  rightChainSetupDateControl = new FormControl(moment());
  rightFrameSetupDateControl = new FormControl(moment());
  leftFrameSetupDateControl = new FormControl(moment());
  success: boolean = false;
  inspection: InspectionUnsyncedVwMdl = new InspectionUnsyncedVwMdl();
  _submitOperation: ResultMessage = new ResultMessage();
  useMax: string;
  frameConfig: number;
  cannonType: number;
  UCSetupType: number = 1;
  _allowToggleCRoller: boolean = false;
  userUOM: string;
  bushTurnedHours: number;
  InspectionCount: number = 0;
  constructor(private _setupService: SetupUndercarriageService, private _appService: AppService, private titleService: Title,
    private _router: Router, private ref: ChangeDetectorRef,
    private _translate: TranslateService,
    private _formBuilder: FormBuilder,
    public snackBar: MatSnackBar,
    private location: Location,
    private _notification: NotificationsService, private _route: ActivatedRoute,
    private _loadingService: LoadingService,
    private _sanitizer: DomSanitizer, private _inspectionsService: UCInspectionsService,
    private readonly _pref: PreferencesService,
    private _userPref: GETPreferencesService, private _equipmentService: SetupEquipmentService,
    private _dialog: MatDialog) {
  }

  ngOnInit() {
    this._appService.setPageTitle('Setup Undercarriage | On Equipment');
    this.getUserPref();
    //this._loadingService.startLoading();
    this.translateSubscription = this._translate._getPrefLang().subscribe(lang => setTimeout(() => { this.updateUserLang(lang); }, 2));

    this._appService.GetDeafultUCSetupType().subscribe((res: any) => {
      this.UCSetupType = res;
      if (this.UCSetupType != 1) {
        this._displayedColumns = ['delete', 'Component', 'Type', 'Pos', 'MLink', 'JobNum', 'AssetNum', 'Size', 'Grouser', 'CleanerHoles'];
      }
    })
    this.firstFormGroup = this._formBuilder.group({
      firstCtrl: ['', Validators.required]
    });
    this.secondFormGroup = this._formBuilder.group({
      secondCtrl: ['', Validators.required]
    });
    this._loading++;
    this._setupService.getShoeSizeList().subscribe(result => {
      this._availableShoeSizes = result;
    }, error => { console.error(error); }, () => { this._loading--; });

    //new code CleanewHOles

    this._setupService.getCleanerHolesList().subscribe(result => {
      this._availableCleanerholes = result;
    }, error => { console.error(error); }, () => { this._loading--; });


    this._loading++;
    this._setupService.getComponentMakeList().subscribe(result => {
      this._availableComponentMakes = result;
      //console.log("Make List", this._availableComponentMakes)
    }, error => { }, () => { this._loading--; });
    this._loading++;
    this._appService.getCustomerListForSelection(1, 10000).subscribe(result => { this._dropDownLists.customerList = result; this._dropDownListsFiltered.customerList = result; this.loadEquipmentByRoute(); }, error => { console.error(error); }, () => { this._loading--; });
    this._loading++;
    this._appService.getJobSiteListForSelection(1, 10000).subscribe(result => { this._dropDownLists.jobSiteList = result; this.loadEquipmentByRoute(); }, error => { console.error(error); }, () => { this._loading--; });
    this._loading++;
    this._appService.getEquipmentListForSetup(1, 20000).subscribe(result => { this._dropDownLists.equipmentList = result; this.loadEquipmentByRoute(); }, error => { console.error(error); }, () => { this._loading--; });
    this._loading++;
    this._appService.getFamilyListForSelection(1, 10000).subscribe(result => { this._dropDownLists.familyList = result; }, error => { console.error(error); }, () => { this._loading--; });
    this._loading++;
    this._appService.getMakeListForSelection(1, 10000).subscribe(result => { this._dropDownLists.makeList = result; }, error => { console.error(error); }, () => { this._loading--; });
    this._loading++;
    // this._appService.getModelListForSelection(1, 10000).subscribe(result => { this._dropDownLists.modelList = result.filter(m => m); }, error => { console.error(error); }, () => { this._loading--; });


    this._appService.getModelList().subscribe(result => { this._dropDownLists.modelList = result.filter(m => m); }, error => { console.error(error); }, () => { this._loading--; });




    this.leftchainTableDatabase = new ComponentTableDatabase(this._leftChainSetup.Components);
    this.leftchainTableDataSource = new ComponentDataSource(this.leftchainTableDatabase);

    this.rightchainTableDatabase = new ComponentTableDatabase(this._rightChainSetup.Components);
    this.rightchainTableDataSource = new ComponentDataSource(this.rightchainTableDatabase);

    this.leftframeTableDatabase = new ComponentTableDatabase(this._leftFrameSetup.Components);
    this.leftframeTableDataSource = new ComponentDataSource(this.leftframeTableDatabase);

    this.rightframeTableDatabase = new ComponentTableDatabase(this._rightFrameSetup.Components);
    this.rightframeTableDataSource = new ComponentDataSource(this.rightframeTableDatabase);

    this.getRouteParam();
    this.FamilyImage_Chain = ""
    this.FamilyImage_Frame = ""
    //this.routeSubscription = this._appService.getRouteMessage().subscribe(message => setTimeout(() => { this.getRouteParam(message); }, 10));
    this._appService.getApplicationConfigValue("UseMaxComponents").subscribe(result => {
      this.useMax = result
    });

    console.log('_currentSelection', this._currentSelection);
  }

  ngOnDestroy() {
    this.translateSubscription.unsubscribe();
    //this.routeSubscription.unsubscribe();
  }

  updateUserLang(lang: string) {
    this.userLanguage = lang;
    this.ref.detectChanges();
  }

  Translate(value: string): string {
    return this._translate.translateToLang(value, this.userLanguage);
  }

  getRouteParam(): void {
    this._routeId = this._route.snapshot.params.id;
    this.loadEquipmentByRoute();
  }
  bShowAllPartsIds: boolean = false;
  ShowPartsIds(event: any) {
    //console.log("this._currentSelection.equipment.EnableDistTravelledTracking: ", this._currentSelection.equipment.EnableDistTravelledTracking)
    this.bShowAllPartsIds = event.checked;
    if (this.UCSetupType == 1) {
      if (this._currentSelection.equipment.EnableDistTravelledTracking) {
        if (this.bShowAllPartsIds) {
          this._displayedColumns = ['delete', 'Component', 'Type', 'Pos', 'Brand', 'OEMPartNo', 'MFRPartNo', 'BudgetLife', 'HoursAtInstall', 'DistanceBudget', 'DOC', 'InstallCost', 'BushTurnedPercent', 'BushTurnedHours', 'MLink', 'JobNum', 'AssetNum', 'Size', 'Grouser', 'CleanerHoles'];
        } else if (!this.bShowAllPartsIds) {
          this._displayedColumns = ['delete', 'Component', 'Type', 'Pos', 'Brand', 'BudgetLife', 'HoursAtInstall', 'DistanceBudget', 'DOC', 'InstallCost', 'BushTurnedPercent', 'BushTurnedHours', 'MLink', 'JobNum', 'AssetNum', 'Size', 'Grouser', 'CleanerHoles'];
        }
      }
      else {
        if (this.bShowAllPartsIds) {
          this._displayedColumns = ['delete', 'Component', 'Type', 'Pos', 'Brand', 'OEMPartNo', 'MFRPartNo', 'BudgetLife', 'HoursAtInstall', 'InstallCost', 'BushTurnedPercent', 'BushTurnedHours', 'MLink', 'JobNum', 'AssetNum', 'Size', 'Grouser', 'CleanerHoles'];
        } else if (!this.bShowAllPartsIds) {
          this._displayedColumns = ['delete', 'Component', 'Type', 'Pos', 'Brand', 'BudgetLife', 'HoursAtInstall', 'InstallCost', 'BushTurnedPercent', 'BushTurnedHours', 'MLink', 'JobNum', 'AssetNum', 'Size', 'Grouser', 'CleanerHoles'];
        }
      }
    }
    else {
      if (this.bShowAllPartsIds) {
        this._displayedColumns = ['delete', 'Component', 'Type', 'Pos', 'MLink', 'JobNum', 'AssetNum', 'Size', 'Grouser', 'CleanerHoles'];
      } else if (!this.bShowAllPartsIds) {
        this._displayedColumns = ['delete', 'Component', 'Type', 'Pos', 'MLink', 'JobNum', 'AssetNum', 'Size', 'Grouser', 'CleanerHoles'];
      }
    }
    //console.log("this._displayedColumns:", this._displayedColumns);
  }
  loadEquipmentByRoute() {
    if (this._routeId == 0) return;
    if (this._currentSelection.equipment.Id == this._routeId)
      return;

    let equipment = this._dropDownLists.equipmentList.find(m => m.Id == this._routeId);
    if (!equipment) return;

    let jobsite = this._dropDownLists.jobSiteList.find(m => m.Id == equipment.JobSiteId);
    if (!jobsite) return;

    const customer = this._dropDownLists.customerList.find(m => m.Id === jobsite.CustomerId);
    if (!customer) return;

    this._currentSelection.customer = customer;
    this.customerChanged({ value: customer });

    this._currentSelection.jobSite = jobsite;
    this.jobsiteChanged({ value: jobsite });

    this.equipmentChanged({ value: equipment });

    this._setupService.CheckEquipmentIsSetup(this._currentSelection.equipment.Id).subscribe(result => {
      if (result) {
        this.isInstalled = true
      } else {
        this.isInstalled = false
      }
    });

  }
  sideChanged(event: any) {
    if (event.value === 3)
      this.openSnackBar(this.Translate('By selecting Both, all details on the right side will be reset to be the same as the left side'), this.Translate('WARNING'));
  }

  handleSkipChainSetup(equipmentId) {
    this._setupService.getEquipmentApplication(equipmentId).subscribe(useSystem => {

      if (useSystem) {
        this.skipChainSetup = false;
      } else {
        this.skipChainSetup = true;
      }
      this.nextStep();
      //console.log(this.skipChainSetup, useSystem);
    });

    this._loading--;
    //this._loadingService.finishedLoading();
  }

  LeftFrameCannonChange(event: any) {
    //console.log("LeftFrameCannonChange", event.value)
    this._leftFrameSetup.cannonType = event.value;
  }
  LeftFrameConfigChange(event: any) {
    //console.log("LeftFrameConfigChange", event.value)
    this._leftFrameSetup.frameConfig = event.value;
    this._rightFrameSetup.frameConfig = event.value;
  }


  RightFrameCannonChange(event: any) {
    //console.log("RightFrameCannonChange", event.value)
    this._rightFrameSetup.cannonType = event.value;
  }

  RightFrameConfigChange(event: any) {
    //console.log("RightFrameConfigChange", event.value, this._leftFrameSetup, this._rightFrameSetup)
    this._rightFrameSetup.frameConfig = event.value;
    this._leftFrameSetup.frameConfig = event.value;
  }
  private selectEquipment(equipment: Equipment) {
    //console.log("this._currentSelection.equipment: ", this._currentSelection.equipment)
    this._currentSelection.equipment = equipment;
    this._loading++;

    this._setupService.GetEquipmentMakeModelFamily(equipment.Id).subscribe(result => {
      equipment.Make = result.Make;
      equipment.Family = result.Family;
      // this.EquipmentFamilyId = result.Family.Id;
      equipment.Model = result.Model;
      this.getFamilyDetails(equipment.Family.Id)
      console.log('equipment.Family', equipment.Family);
      //if (equipment.Family.Id == 177 || equipment.Family.Id == 203) {
      if (equipment.ShowPropelHrsPerc) {
        if(this.UCSetupType == 1)
          this._displayedColumns = ['delete', 'Component', 'Type', 'Pos', 'Brand', 'BudgetLife', 'HoursAtInstall', 'PMUAtInstall', 'InstallCost', 'BushTurnedPercent', 'BushTurnedHours', 'MLink', 'JobNum', 'AssetNum', 'Size', 'Grouser', 'CleanerHoles'];
        else 
          this._displayedColumns = ['delete', 'Component', 'Type', 'Pos', 'MLink', 'JobNum', 'AssetNum', 'Size', 'Grouser', 'CleanerHoles'];
      }
      this.updateAvailableComparts();
      if (!this._availableComponentMakes.find(m => m.Id === result.Make.Id)) {
        this._availableComponentMakes.unshift(result.Make);
        //console.log("mKAe Updted", this._availableComponentMakes)
      }

      this._loading++;
      this._setupService.GetEquipmentUnsyncedId(equipment.Id).subscribe(resultUnsynced => { if (resultUnsynced) this._unsyncedId = resultUnsynced; }, error => { console.error(error); }, () => { this._loading--; });

      this._loading++;
      this._systemTemplate = [];
      this._setupService.GetTemplateForEquipment(equipment.Id).subscribe(template => {
        this._systemTemplate.push(...template);
        this._loading++;
        this._setupService.GetEquipmentSystems(equipment.Id).subscribe(systems => {
          //console.log("System__new___", systems)
          this._currentSelection.equipment.Systems.push(...systems);
          if (this._currentSelection.equipment.Systems.length > 0) {
            this._selectedSide = 1;
            this._itIsUpdate = true;
          }
          this._defaultCMUsAreSet = false;
          this.setEquipmentSystems();
        }, error => { console.error(error); }, () => { this._loading--; });
      }, error => { console.error(error); }, () => { this._loading--; });
    }, error => { console.error(error); }, () => { this._loading--; });
    //console.log("this._currentSelection.equipment-2: ", this._currentSelection.equipment)
  }
  isBothDisable: boolean = false;
  disableBoth(): boolean {
    if (this._currentSelection.equipment.Systems.length > 0) {

      this.isBothDisable = true;
      return true;


    } else {
      this.isBothDisable = false;
      return false;
    }

  }

  setEquipmentSystems_leftChain(): Promise<boolean> {
    return new Promise<boolean>(resolve => {
      if (this._currentSelection.equipment.Systems.filter(m => m.SystemType === SystemType.Chain && m.Side === Side.Left).length === 0) {
        this._leftChainSetup.SmuAtInstall = this._currentSelection.equipment.SmuAtSetup;
        this._leftChainSetup.PropelAtInstall = this._currentSelection.equipment.PropelAtSetup;
        this._leftChainSetup.InstallationDate = this._currentSelection.equipment.SetupDate;
        this._leftChainSetup.Side = Side.Left;
        this._leftChainSetup.Type = SystemType.Chain;
        this._leftChainSetup.JobsiteId = this._currentSelection.equipment.JobSiteId;
        this._leftChainSetup.EquipmentId = this._currentSelection.equipment.Id;
        this._leftChainSetup.Make = this._currentSelection.equipment.Make;
        this._leftChainSetup.Model = this._currentSelection.equipment.Model;
        this._leftChainSetup.Family = this._currentSelection.equipment.Family;
        this._leftChainSetup.HistoricalDistance = 0;
        this._leftChainSetup.BudgetDistance = 0;
        this._leftChainSetup.TotalDistance = this._currentSelection.equipment.DistanceOnEqAtInstall;
        this.setSystemComponents(SystemTypeSide.LeftChain);
        resolve(true);
      }
      else {
        this._loading++;
        const id = this._currentSelection.equipment.Systems.find(m => m.SystemType === SystemType.Chain && m.Side === Side.Left).Id;
        this._setupService.getSystemForSetupUpdate(id).subscribe(
          result => {
            this._leftChainSetup = result;
            console.log("Left Chain Setup", this._leftChainSetup);
            this._leftChainSetup.InstallationDate = this.dateOnlyFromUTCString(result.InstallationDate.toString());
            this.setSystemComponents(SystemTypeSide.LeftChain);
            this.leftchainTableDatabase.dataChange.next(this._leftChainSetup.Components);
          }, error => { console.error(error); }, () => { this._loading--; resolve(true); }
        );
      }
    });
  }

  setEquipmentSystems_rightChain(): Promise<boolean> {
    return new Promise<boolean>(resolve => {
      if (this._currentSelection.equipment.Systems.filter(m => m.SystemType === SystemType.Chain && m.Side === Side.Right).length === 0) {
        this._rightChainSetup.SmuAtInstall = this._currentSelection.equipment.SmuAtSetup;
        this._rightChainSetup.PropelAtInstall = this._currentSelection.equipment.PropelAtSetup;
        this._rightChainSetup.InstallationDate = this._currentSelection.equipment.SetupDate;
        this._rightChainSetup.Side = Side.Right;
        this._rightChainSetup.Type = SystemType.Chain;
        this._rightChainSetup.JobsiteId = this._currentSelection.equipment.JobSiteId;
        this._rightChainSetup.EquipmentId = this._currentSelection.equipment.Id;
        this._rightChainSetup.Make = this._currentSelection.equipment.Make;
        this._rightChainSetup.Model = this._currentSelection.equipment.Model;
        this._rightChainSetup.Family = this._currentSelection.equipment.Family;
        this._rightChainSetup.HistoricalDistance = 0;
        this._rightChainSetup.BudgetDistance = 0;
        this._rightChainSetup.TotalDistance = this._currentSelection.equipment.DistanceOnEqAtInstall;
        this.setSystemComponents(SystemTypeSide.RightChain);
        resolve(true);
      } else {
        this._loading++;
        this._setupService.getSystemForSetupUpdate(this._currentSelection.equipment.Systems.find(m => m.SystemType === SystemType.Chain && m.Side === Side.Right).Id).subscribe(
          result => {
            this._rightChainSetup = result;
            this._rightChainSetup.InstallationDate = this.dateOnlyFromUTCString(result.InstallationDate.toString());
            this.setSystemComponents(SystemTypeSide.RightChain);
            this.rightchainTableDatabase.dataChange.next(this._rightChainSetup.Components);
          }, error => { console.error(error); }, () => { this._loading--; resolve(true); }
        );
      }
    });
  }

  setEquipmentSystems_leftFrame(): Promise<boolean> {
    return new Promise<boolean>(resolve => {
      if (this._currentSelection.equipment.Systems.filter(m => m.SystemType === SystemType.Frame && m.Side === Side.Left).length === 0) {
        this._leftFrameSetup.SmuAtInstall = this._currentSelection.equipment.SmuAtSetup;
        this._leftFrameSetup.PropelAtInstall = this._currentSelection.equipment.PropelAtSetup;
        this._leftFrameSetup.InstallationDate = this._currentSelection.equipment.SetupDate;
        this._leftFrameSetup.Side = Side.Left;
        this._leftFrameSetup.Type = SystemType.Frame;
        this._leftFrameSetup.JobsiteId = this._currentSelection.equipment.JobSiteId;
        this._leftFrameSetup.EquipmentId = this._currentSelection.equipment.Id;
        this._leftFrameSetup.Make = this._currentSelection.equipment.Make;
        this._leftFrameSetup.Model = this._currentSelection.equipment.Model;
        this._leftFrameSetup.Family = this._currentSelection.equipment.Family;
        this._leftFrameSetup.HistoricalDistance = 0;
        this._leftFrameSetup.BudgetDistance = 0;
        this._leftFrameSetup.TotalDistance = this._currentSelection.equipment.DistanceOnEqAtInstall;
        this.setSystemComponents(SystemTypeSide.LeftFrame);
        resolve(true);
      } else {
        this._loading++;
        this._setupService.getSystemForSetupUpdate(this._currentSelection.equipment.Systems.find(m => m.SystemType === SystemType.Frame && m.Side === Side.Left).Id).subscribe(
          result => {
            this._leftFrameSetup = result;
            this._leftFrameSetup.InstallationDate = this.dateOnlyFromUTCString(result.InstallationDate.toString());
            this.setSystemComponents(SystemTypeSide.LeftFrame);
            this.leftframeTableDatabase.dataChange.next(this._leftFrameSetup.Components);
          }, error => { console.error(error); }, () => { this._loading--; resolve(true); }
        );
      }
    });
  }

  setEquipmentSystems_rightFrame(): Promise<boolean> {
    return new Promise<boolean>(resolve => {
      if (this._currentSelection.equipment.Systems.filter(m => m.SystemType === SystemType.Frame && m.Side === Side.Right).length === 0) {
        this._rightFrameSetup.SmuAtInstall = this._currentSelection.equipment.SmuAtSetup;
        this._rightFrameSetup.PropelAtInstall = this._currentSelection.equipment.PropelAtSetup;
        this._rightFrameSetup.InstallationDate = this._currentSelection.equipment.SetupDate;
        this._rightFrameSetup.Side = Side.Right;
        this._rightFrameSetup.Type = SystemType.Frame;
        this._rightFrameSetup.JobsiteId = this._currentSelection.equipment.JobSiteId;
        this._rightFrameSetup.EquipmentId = this._currentSelection.equipment.Id;
        this._rightFrameSetup.Make = this._currentSelection.equipment.Make;
        this._rightFrameSetup.Model = this._currentSelection.equipment.Model;
        this._rightFrameSetup.Family = this._currentSelection.equipment.Family;
        this._rightFrameSetup.HistoricalDistance = 0;
        this._rightFrameSetup.BudgetDistance = 0;
        this._rightFrameSetup.TotalDistance = this._currentSelection.equipment.DistanceOnEqAtInstall;
        this.setSystemComponents(SystemTypeSide.RightFrame);
        resolve(true);
      }
      else {
        this._loading++;
        this._setupService.getSystemForSetupUpdate(this._currentSelection.equipment.Systems.find(m => m.SystemType === SystemType.Frame && m.Side === Side.Right).Id).subscribe(
          result => {
            this._rightFrameSetup = result;
            this._rightFrameSetup.InstallationDate = this.dateOnlyFromUTCString(result.InstallationDate.toString());
            this.setSystemComponents(SystemTypeSide.RightFrame);
            this.rightframeTableDatabase.dataChange.next(this._rightFrameSetup.Components);
          }, error => { console.error(error); }, () => { this._loading--; resolve(true); }
        );
      }
    });
  }

  setEquipmentSystems() {

    this.setEquipmentSystems_leftChain().then(lc => {
      this.setEquipmentSystems_rightChain().then(rc => {
        this.setEquipmentSystems_leftFrame().then(lf => {
          this.setEquipmentSystems_rightFrame().then(rf => {

            this.leftchainTableDatabase.dataChange.next(this._leftChainSetup.Components);
            this.rightchainTableDatabase.dataChange.next(this._rightChainSetup.Components);
            this.leftframeTableDatabase.dataChange.next(this._leftFrameSetup.Components);
            this.rightframeTableDatabase.dataChange.next(this._rightFrameSetup.Components);

            this.handleSkipChainSetup(this._currentSelection.equipment.Id);
          });
        });
      });
    });

  }
  isInstalled: boolean = false;
  setSystemComponents(_typeSide: SystemTypeSide) {
    //console.log("this._leftChainSetup: Component : ", this._leftChainSetup)
    //console.log("this._leftFrameSetup.Components", this._leftFrameSetup.Components)
    let modelTemplateList: SystemModelTemplate[] = [];
    if (_typeSide === SystemTypeSide.LeftChain || _typeSide === SystemTypeSide.RightChain)
      modelTemplateList = this._setupService.getModelTemplateListForChain(this._systemTemplate);
    else if (_typeSide === SystemTypeSide.LeftFrame || _typeSide === SystemTypeSide.RightFrame)
      modelTemplateList = this._setupService.getModelTemplateListForFrame(this._systemTemplate);
    const components: ComponentSetup[] = [];
    const listposition = 1;
    var value;
    if (_typeSide === SystemTypeSide.LeftChain) {
      for (const template of modelTemplateList) {
        const existingNumber = this._leftChainSetup.Components.filter(m => m.Compart.CompartType.Id === template.CompartTypeId).length;
        if (this.isInstalled) {
          //console.log("isInstalled ", this._leftChainSetup)
        }
        else {
          if (this.useMax == "0")
            value = template.Min;
          else
            value = template.Max;
          if (this._allowToggleCRoller && template.CompartTypeId == 234)
            value = 1;
          for (let k = existingNumber; k < value; k++) {
            const newcomponent = this.getNewDefaultComponent(template.CompartTypeId);
            newcomponent.InstallDate = this._leftChainSetup.InstallationDate;
            newcomponent.EquipmentSMU = this._leftChainSetup.SmuAtInstall;
            newcomponent.PropelHrs = this._leftChainSetup.PropelAtInstall;
            newcomponent.SystemId = this._leftChainSetup.Id;
            newcomponent.DOC = this._leftChainSetup.HistoricalDistance;
            newcomponent.DistanceBudget = 0;
            newcomponent.Pos = k + 1;
            this._leftChainSetup.Components.push(newcomponent);
          }
        }

      }
    }
    else if (_typeSide === SystemTypeSide.RightChain) {
      for (const template of modelTemplateList) {
        const existingNumber = this._rightChainSetup.Components.filter(m => m.Compart.CompartType.Id === template.CompartTypeId).length;
        if (this.isInstalled) {
        }
        else {
          if (this.useMax == "0")
            value = template.Min;
          else
            value = template.Max;
          for (let k = existingNumber; k < value; k++) {
            const newcomponent = this.getNewDefaultComponent(template.CompartTypeId);
            newcomponent.InstallDate = this._rightChainSetup.InstallationDate;
            newcomponent.EquipmentSMU = this._rightChainSetup.SmuAtInstall;
            newcomponent.PropelHrs = this._rightChainSetup.PropelAtInstall;
            newcomponent.SystemId = this._rightChainSetup.Id;
            newcomponent.DOC = this._rightChainSetup.HistoricalDistance;
            newcomponent.DistanceBudget = 0;
            newcomponent.Pos = k + 1;
            this._rightChainSetup.Components.push(newcomponent);
          }
        }

      }
    }
    else if (_typeSide === SystemTypeSide.LeftFrame) {
      for (const template of modelTemplateList) {
        const existingNumber = this._leftFrameSetup.Components.filter(m => m.Compart.CompartType.Id === template.CompartTypeId).length;
        if (this.isInstalled) {
        }
        else {
          if (this.useMax == "0")
            value = template.Min;
          else
            value = template.Max;
          for (let k = existingNumber; k < value; k++) {
            const newcomponent = this.getNewDefaultComponent(template.CompartTypeId);
            newcomponent.InstallDate = this._leftFrameSetup.InstallationDate;
            newcomponent.EquipmentSMU = this._leftFrameSetup.SmuAtInstall;
            newcomponent.PropelHrs = this._leftFrameSetup.PropelAtInstall;
            newcomponent.SystemId = this._leftFrameSetup.Id;
            newcomponent.DOC = this._leftFrameSetup.HistoricalDistance;
            newcomponent.DistanceBudget = 0;
            newcomponent.Pos = k + 1;
            this._leftFrameSetup.Components.push(newcomponent);
          }
        }

      }
    }
    else if (_typeSide === SystemTypeSide.RightFrame) {
      for (const template of modelTemplateList) {
        const existingNumber = this._rightFrameSetup.Components.filter(m => m.Compart.CompartType.Id === template.CompartTypeId).length;
        if (this.isInstalled) { }
        else {
          if (this.useMax == "0")
            value = template.Min;
          else
            value = template.Max;
          for (let k = existingNumber; k < value; k++) {
            const newcomponent = this.getNewDefaultComponent(template.CompartTypeId);
            newcomponent.InstallDate = this._rightFrameSetup.InstallationDate;
            newcomponent.EquipmentSMU = this._rightFrameSetup.SmuAtInstall;
            newcomponent.PropelHrs = this._rightFrameSetup.PropelAtInstall;
            newcomponent.SystemId = this._rightFrameSetup.Id;
            newcomponent.DOC = this._rightFrameSetup.HistoricalDistance;
            newcomponent.DistanceBudget = 0;
            newcomponent.Pos = k + 1;
            this._rightFrameSetup.Components.push(newcomponent);
          }
        }
      }
    }
    this.reorderSystemComponents(_typeSide);
    this.resetSelectedListIndex(_typeSide);
  }

  private getNewDefaultComponent(typeId: number): ComponentSetup {
    const result = new ComponentSetup();
    result.Compart.CompartType = this._setupService.getAvailableCompartTypeList().find(m => m.Id === typeId);
    const EqBrand = this._availableComponentMakes.find(m => m.Id === this._currentSelection.equipment.Make.Id);
    if (EqBrand)
      result.Brand = EqBrand;
    return result;
  }

  customerChanged(event: any): void {
    const customer: Customer = event.value;
    if (!customer) return;
    this._dropDownListsFiltered.jobSiteList = this._dropDownLists.jobSiteList.filter(m => m.CustomerId === customer.Id);
    this._currentSelection.jobSite = new JobSite();
    this._dropDownListsFiltered.equipmentList = [];
    this._currentSelection.equipment = new Equipment();
  }

  jobsiteChanged(event: any): void {
    const jobsite: JobSite = event.value;
    if (!jobsite) return;
    this._dropDownListsFiltered.equipmentList = this._dropDownLists.equipmentList.filter(m => m.JobSiteId === jobsite.Id);
    this._currentSelection.equipment = new Equipment();
  }

  GetInspectionCount(equipmentId: number, equipmentSerial: string) {
    this._equipmentService.GetEquipmentInspectionCount(equipmentId).subscribe(res => {
      if (res != null)
        this.InspectionCount = res;
      if (this.InspectionCount <= 2) {
        if (equipmentId !== 0) {
          this.location.go('setup-undercarriage/on-equipment/' + equipmentId);
          this._appService.setPageTitle('Setup Undercarriage | On Equipment ' + equipmentSerial);
        }
      }
    });
  }

  equipmentChanged(event: any): void {
    const equipment: Equipment = new Equipment();
    equipment.Id = event.value.Id;
    equipment.JobSiteId = event.value.JobSiteId;
    equipment.Serial = event.value.Serial;
    equipment.Unit = event.value.Unit;
    equipment.SmuAtSetup = event.value.SmuAtSetup;
    equipment.PropelAtSetup = event.value.PropelAtSetup;
    equipment.SetupDate = this.dateOnlyFromUTCString(event.value.SetupDate);
    equipment.EnableDistTravelledTracking = event.value.EnableDistTravelledTracking;
    equipment.ShowPropelHrsPerc = event.value.ShowPropelHrsPerc;
    equipment.DistanceOnEqAtInstall = event.value.DistanceOnEqAtInstall;

    if (!equipment) return;
    this.selectEquipment(equipment);
    this.GetInspectionCount(equipment.Id, equipment.Serial);

  }

  // returning true makes button disable
  checkTemplateForCompartTypeButton(_typeSide: SystemTypeSide, typeId: number): boolean {
    if (this.getCompartTypeRemainingOptional(_typeSide, typeId) > 0)
      return false;
    return true;
  }

  checkTemplateForCompartRemoveFromList(_typeSide: SystemTypeSide, typeId: number, element: ComponentSetup): boolean {
    const _selectedComponents = this.getSystembyTypeSide(_typeSide).Components;
    const template = this._systemTemplate.find(m => m.ModelId === this._currentSelection.equipment.Model.Id && m.CompartTypeId === typeId);
    const count = _selectedComponents.filter(m => m.Compart.CompartType.Id === typeId).length;
    if (typeId == 234 || typeId == 235) {
      if (template && count > template.Min) {
        if (count == element.Pos) {
          return true;
        }
      }

    } else {
      if (template && count > template.Min) return true;
    }
    // if (template && count > template.Min) return true;
    return false;
  }

  private updateAvailableComparts() {
    this._loading++;
    this._currentAvailableTypes = [];
    this._setupService.GetAvailableCompartsAll(this._currentSelection.equipment.Model.Id).subscribe(result => {
      this._currentAvailableTypes.push(...result);
    }, error => { }, () => { this._loading--; });
  }

  getAvailableCompartList(typeId: number): Compart[] {
    return this._currentAvailableTypes.filter(m => m.CompartType.Id === typeId);
  }

  getAvailableCompartListFiltered(typeId: number): Compart[] {
    if (!this.bShowAllParts && typeId == 231) {
      if (this._selectedSide == 1 && this.sFilterBySameCompartIdL.trim().length > 0) {
        return this.getAvailableCompartList(typeId).filter(f => f.CompartStr == this.sFilterBySameCompartIdL);
      }
      else if (this._selectedSide == 2 && this.sFilterBySameCompartIdR.trim().length > 0) {
        return this.getAvailableCompartList(typeId).filter(f => f.CompartStr == this.sFilterBySameCompartIdR);
      }
      else if (this._selectedSide == 3 && this.sFilterBySameCompartIdB.trim().length > 0) {
        return this.getAvailableCompartList(typeId).filter(f => f.CompartStr == this.sFilterBySameCompartIdB);
      }
    }

    return this.getAvailableCompartList(typeId);
  }

  private getEquipmentSystems(equipmentId: number) {
    this._loading++;
    this._setupService.GetEquipmentSystems(equipmentId).subscribe(result => {
      this._currentSelection.equipment.Systems = [];
      this._currentSelection.equipment.Systems.push(...result);
    }, error => { console.error(error); }, () => { this._loading--; });
  }

  sideTabChanged(event) {
    this._selectedSide = event.index + 1;
  }

  private updatemodelMatchingLabel(_typeSide: SystemTypeSide, typeId: number) {
    const _currentSystem = this.getSystembyTypeSide(_typeSide);
    const k = this.getCompartTypeRemainingRequired(_typeSide, typeId);
    const p = this.getCompartTypeRemainingOptional(_typeSide, typeId);
  }

  CompartSelectedOnly(event: any, element: ComponentSetup) {
    if (!event.value) return;
    const selected = this._currentAvailableTypes.find(m => m.Id === event.value);
    if (!selected) return;
    element.Compart = selected;
    if (selected.CompartType.Id == 231) {
      this.getBushTurnedHours(element);
    }
  }
  CompartSelected(event: any, element: ComponentSetup) {
    //console.log("element - 1:", element);
    if (!event.value) return;
    const selected = this._currentAvailableTypes.find(m => m.Id === event.value);
    if (!selected) return;
    element.Compart = selected;
    //if (selected.BudgetLife === 0) {
    //  if (element.BudgetLife === 0 || element.BudgetLife === null) {
    //    element.BudgetLife = selected.DefaultBudgetLife;
    //  }
    //} else {
    //  element.BudgetLife = selected.BudgetLife;
    //}
    //if (element.DistanceBudget === 0 || element.DistanceBudget === null) {
    //  element.DistanceBudget = selected.DefaultDistanceBudget;
    //}
    element.BudgetLife = selected.DefaultBudgetLife;
    element.DistanceBudget = selected.DefaultDistanceBudget;
    // this.bushTurnedHours = (element.BudgetLife * element.BushTurnedPercent) / 100;
    // console.log("bushTurnedHours:", this.bushTurnedHours);
    //console.log("element - 2:", element);
    //element.DistanceBudget = 0;
    //console.log("element.DistanceBudget:" ,element.DistanceBudget);
    //if (selected.DefaultMake.Id === 0) return;
    if (selected.DefaultMake.Id > 0) {
      if (element.Brand.Id === null || element.Brand.Id === 0) {
        if (this._availableComponentMakes.find(m => m.Id === selected.DefaultMake.Id))
          element.Brand = selected.DefaultMake;
      }
    }

    // TT-1344: Check if (Id==0) to fix issue with it overriding any user selections.
    //get default Grouser
    if (element.Grouser.Id == 0) {
      if (selected.GrouserNum > 0) {
        if (this._availableGrousers.find(m => m.Id === selected.GrouserNum))
          element.Grouser.Id = selected.GrouserNum;
      } else {
        element.Grouser.Id = selected.GrouserNum;
      }
    }

    if (element.HasCleanerHoles == 0) {
      if (selected.HasCleanerHole > 0) {
        element.HasCleanerHoles = selected.HasCleanerHole;
      } else {
        element.HasCleanerHoles = selected.HasCleanerHole;
      }
    }

    // TT-1272
    if (selected.CompartType.Id == 230) {
      var numComponents = this.getAvailableCompartList(231).filter(f => f.CompartStr == selected.CompartStr).length;

      // Left
      if (this._selectedSide == 1) {
        if (numComponents > 0) {
          this.sFilterBySameCompartIdL = selected.CompartStr;
        } else {
          this.sFilterBySameCompartIdL = "";
        }
      }
      // Right
      else if (this._selectedSide == 2) {
        if (numComponents > 0) {
          this.sFilterBySameCompartIdR = selected.CompartStr;
        } else {
          this.sFilterBySameCompartIdR = "";
        }
      }
      // Both
      else if (this._selectedSide == 3) {
        if (numComponents > 0) {
          this.sFilterBySameCompartIdB = selected.CompartStr;
        } else {
          this.sFilterBySameCompartIdB = "";
        }
      }
    }
    if (selected.CompartType.Id == 231) {
      this.getBushTurnedHours(element);
    }
  }

  shouldSelectDefault(element: ComponentSetup) {
    //console.log("shouldSelectDefault element - 1:", element);
    const compartElement = this.getAvailableCompartList(element.Compart.CompartType.Id);
    if (element.Compart.Id !== 0 && compartElement.length > 0) {
      this.CompartSelectedOnly({ value: element.Compart.Id }, element);

      return element.Compart.Id;
    } else
      if (compartElement !== undefined && compartElement !== null && compartElement.length === 1) {
        this.CompartSelected({ value: compartElement[0].Id }, element);
        return element.Compart.Id;
      }
  }



  soheSizeSelected(event: any, element: ComponentSetup) {
    if (!event.value)
      return;
    const selected = this._availableShoeSizes.find(m => m.Id === event.value);
    if (!selected)
      return;
    element.ShoeSize = selected;
  }

  grouserSelected(event: any, element: ComponentSetup) {
    if (!event.value) return;
    const selected = this._availableGrousers.find(m => m.Id === event.value);
    if (!selected) return;
    element.Grouser.Id = selected.Id;

  }

  cleanerHolesChange(event: any, element: ComponentSetup) {
    console.log("event.value_____", event.value)
    if (!event.value) return;
    const selected = event.value;
    if (!selected) return;
    element.HasCleanerHoles = selected;

  }

  MLinkChange(event: any, element: ComponentSetup) {
    console.log("event.value_____", event.value)
    if (!event.value) return;
    const selected = event.value;
    if (!selected) return;
    element.MLink = selected;

  }

  brandSelected(event: any, element: ComponentSetup) {
    if (!event.value) {
      return;
    }
    const selected = this._availableComponentMakes.find(m => m.Id === event.value);
    if (!selected) {
      return;
    }
    element.Brand = selected;
    const dialogRef = this._dialog.open(ConfirmationBoxComponent, {
      disableClose: true,
      data: {
        title: 'Apply Brand to All Components',
        message: 'Would you like to populate all of the components brands with this brand?'
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result?.confirmed) {
        this.applyToSelectedSide(component => {
          component.Brand = selected;
        });
      }
    });
  }

  budgetLifeChanged(element: ComponentSetup) {
    const dialogRef = this._dialog.open(ConfirmationBoxComponent, {
      disableClose: true,
      data: {
        title: 'Apply Budget Life to All Components',
        message: 'Would you like to populate all of the components budget life with this value?'
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result?.confirmed) {
        const budgetLife = element.BudgetLife;
        this.applyToSelectedSide(component => {
          component.BudgetLife = budgetLife;
        });
      }
    });
  }

  private applyToSelectedSide(action: (component: ComponentSetup) => void): void {
    const apply = (components: ComponentSetup[]) =>
      components.forEach(action);
    switch (this._selectedSide) {
      case 1: // Left
        apply(this._leftChainSetup.Components);
        apply(this._leftFrameSetup.Components);
        break;
      case 2: // Right
        apply(this._rightChainSetup.Components);
        apply(this._rightFrameSetup.Components);
        break;
      case 3: // Both
      default:
        apply(this._leftChainSetup.Components);
        apply(this._rightChainSetup.Components);
        apply(this._leftFrameSetup.Components);
        apply(this._rightFrameSetup.Components);
        break;
    }
  }

  addComponent(_typeSide: SystemTypeSide, typeId: number) {
    const system = this.getSystembyTypeSide(_typeSide);
    if (this.getCompartTypeRemainingOptional(_typeSide, typeId) === 0) {
      this.openSnackBar(this.Translate('Cannot add more components of this type!'), this.Translate('NOT ALLOWED'));
      return;
    }
    const component = this.getNewDefaultComponent(typeId);
    component.Pos = this.getNewPosition(_typeSide, typeId);
    component.InstallDate = system.InstallationDate;
    component.EquipmentSMU = system.SmuAtInstall;
    component.PropelHrs = system.PropelAtInstall;

    component.SystemId = system.Id;
    component.listPosition = system.Components.length + 1;
    component.HoursAtInstall = system.HoursAtInstall;
    component.DOC = system.HistoricalDistance;
    system.Components.push(component);

    this.resetSystemPositionIndex(_typeSide);
    this.reorderSystemComponents(_typeSide);
    this.resetSelectedListIndex(_typeSide);

    this.updateTableView(_typeSide);
  }

  removeElement(_typeSide: SystemTypeSide, element: ComponentSetup): void {
    this._notification.warn("Data could be lost.")
    const system = this.getSystembyTypeSide(_typeSide);
    const component = system.Components.findIndex(m => m.listPosition === element.listPosition && m.Id === element.Id);
    if (component < 0) {
      this.openSnackBar(this.Translate('Cannot find this component to remove!'), this.Translate('FAILED!'));
      return;
    }

    system.Components.splice(component, 1);
    this.reorderSystemComponents(_typeSide);
    this.resetSelectedListIndex(_typeSide);
    this.resetSystemPositionIndex(_typeSide);
    this.updateTableView(_typeSide);
  }

  updateTableView(_typeSide: SystemTypeSide) {
    if (_typeSide === SystemTypeSide.LeftChain)
      this.leftchainTableDatabase.dataChange.next(this._leftChainSetup.Components);
    else if (_typeSide === SystemTypeSide.RightChain)
      this.rightchainTableDatabase.dataChange.next(this._rightChainSetup.Components);
    else if (_typeSide === SystemTypeSide.LeftFrame)
      this.leftframeTableDatabase.dataChange.next(this._leftFrameSetup.Components);
    else if (_typeSide === SystemTypeSide.RightFrame)
      this.rightframeTableDatabase.dataChange.next(this._rightFrameSetup.Components);
  }

  getNewPosition(_typeSide: SystemTypeSide, typeId: number): number {
    const system = this.getSystembyTypeSide(_typeSide);
    const filtered = system.Components.filter(m => m.Compart.CompartType.Id === typeId);
    if (filtered) {
      const lastposition = Math.max(...filtered.map(m => m.Pos));
      console.log(lastposition);
      return lastposition + 1;
    }
    return 1;
  }

  systemSmuDateValidation(_typeSide: SystemTypeSide): ResultMessage {
    const result: ResultMessage = new ResultMessage();
    result.OperationSucceed = false;
    const systemsArray: SystemSetup[] = [this._leftChainSetup, this._rightChainSetup, this._leftFrameSetup, this._rightFrameSetup];
    const system = systemsArray.splice(_typeSide - 1, 1).pop();

    if (system.InstallationDate < this._currentSelection.equipment.SetupDate) {
      result.Id = 1; // Id -> 1 means date failed
      result.LastMessage = this.Translate('Invalid date: Installation date is before equipment setup date!') + ' ' + this.Translate('Equipment Setup Date: ') + this.formatDate(this._currentSelection.equipment.SetupDate);
      return result;
    }

    if (system.SmuAtInstall < this._currentSelection.equipment.SmuAtSetup && system.InstallationDate >= this._currentSelection.equipment.SetupDate) {
      result.Id = 2; // Id -> 2 means SMU failed
      result.LastMessage = this.Translate('Invalid SMU/HourMeter Reading: SMU/HourMeter at install cannot be less than') + ' ' + this._currentSelection.equipment.SmuAtSetup;
      return result;
    }

    //if (this._currentSelection.equipment.Family.Id == 177 || this._currentSelection.equipment.Family.Id == 203) {
    if (this._currentSelection.equipment.ShowPropelHrsPerc) {
      if (Number(system.HoursAtInstall) < Number(system.PMUAtInstall)) {
        result.Id = 3; // Id -> 2 means SMU failed
        result.LastMessage = this.Translate('Invalid PMU Reading: PMU(When installed on equipment) cannot be grater than Life(When installed on equipment) ');
        return result;
      }
    }



    for (const other of systemsArray) {
      if (system.InstallationDate === other.InstallationDate && system.SmuAtInstall !== other.SmuAtInstall) {
        result.Id = 2; // Id -> 2 means SMU failed
        result.LastMessage = this.Translate('Invalid SMU/HourMeter Reading: For the same date SMU/HourMeter has conflict ') + (other.Serial.length > 0 ? this.Translate('with ') + other.Serial + ' !' : '!');
        return result;
      }

      if (system.InstallationDate < other.InstallationDate && system.SmuAtInstall > other.SmuAtInstall) {
        result.Id = 2; // Id -> 2 means SMU failed
        result.LastMessage = this.Translate('Invalid SMU/HourMeter: For ') + this.formatDate(system.InstallationDate) + this.Translate(' SMU/HourMeter has conflict ') + (other.Serial.length > 0 ? this.Translate('with ') + other.Serial + ' !' : '!');
        return result;
      }

      if (system.InstallationDate > other.InstallationDate && system.SmuAtInstall < other.SmuAtInstall) {
        result.Id = 2; // Id -> 2 means SMU failed
        result.LastMessage = this.Translate('Invalid SMU/HourMeter: For ') + this.formatDate(system.InstallationDate) + this.Translate(' SMU/HourMeter has conflict ') + (other.Serial.length > 0 ? this.Translate('with ') + other.Serial + ' !' : '!');
        return result;
      }
    }
    result.Id = 0;
    result.OperationSucceed = true;
    result.LastMessage = this.Translate('SMU/HourMeter and Date validation passed!');
    return result;
  }

  logSystems() {
    console.log('available shoe sizes', this._availableShoeSizes);
    console.log('available shoe grouser', this._availableGrousers);
    console.log('available types', this._currentAvailableTypes);
    console.log('leftChain:', this._leftChainSetup);
    console.log('rightChain:', this._rightChainSetup);
    console.log('leftFrame:', this._leftFrameSetup);
    console.log('RightFrame:', this._rightFrameSetup);
  }

  resetCurrent() {

  }

  resetCurrentCompart() {

  }

  private reorderSystemComponents(_typeSide: SystemTypeSide) {
    const system = this.getSystembyTypeSide(_typeSide);
    system.Components = system.Components.sort((a, b) => this.compartOrder(a, b));
  }

  private resetSelectedListIndex(_typeSide: SystemTypeSide) {
    const system = this.getSystembyTypeSide(_typeSide);
    let k = 0;
    for (const i of system.Components) {
      i.listPosition = ++k;
    }
  }

  private resetSystemPositionIndex(_typeSide: SystemTypeSide) {
    const components = this.getSystembyTypeSide(_typeSide).Components;
    for (const t of this._setupService.getAvailableCompartTypeList()) {
      const filtered = components.filter(m => m.Compart.CompartType.Id === t.Id).sort((a, b) => (a.Pos > b.Pos ? 1 : -1));
      let k = 0;
      for (const p of filtered) {
        p.Pos = ++k;
      }
    }
    return components;
  }


  private compartOrder(a: ComponentSetup, b: ComponentSetup): number {

    if (a.Compart.CompartType.Order > b.Compart.CompartType.Order)
      return 1;
    if (a.Compart.CompartType.Order < b.Compart.CompartType.Order)
      return -1;
    if (a.Pos > b.Pos)
      return 1;
    return -1;
  }

  confirmClearAll() {
    if (confirm('You are removing all data! Are you sure?')) {

    }
  }

  private validateSystemUpdateOnEquipment(): ResultMessage {
    const result = new ResultMessage();
    result.OperationSucceed = false;
    if (this._loading > 0) {
      result.LastMessage = this.Translate('Something is loading please try again after loading completed!');
      return result;
    }

    result.OperationSucceed = true;
    return result;
  }



  ///Please validate side by side -> cannot return correct results for side == both
  private validateSystemInstall(_side: Side, _type: SystemType): ResultMessage {
    const result = new ResultMessage();

    result.OperationSucceed = false;
    if (this._loading > 0) {
      result.LastMessage = this.Translate('Something is loading please try again after loading completed!');
      return result;
    }

    const eqSystem = this._currentSelection.equipment.Systems.find(m => m.Side.valueOf() === _side.valueOf() && m.SystemType.valueOf() === _type.valueOf());

    if (eqSystem) {
      const sideStr = _side === Side.Left ? this.Translate('left side') : this.Translate('right side');
      result.LastMessage = this.Translate('System already exist on ') + sideStr + '!';
      return result;
    }

    result.OperationSucceed = true;
    return result;
  }

  validateSystem() {
    return true;
  }
  // Returns 5 -> success <i class="material-icons">check_circle</i>
  // Returns 1 -> ready for submit  <i class="material-icons">schedule</i>
  // Returns 2 -> warning <i class="material-icons">warning</i>
  // Returns 3 -> submitting <mat-spinner></mat-spinner>
  // Returns 4 -> error <i class="material-icons">error</i>
  componentStatus(_typeSide: SystemTypeSide, listNo: number): number {
    const _system = this.getSystembyTypeSide(_typeSide);
    const current = _system.Components.find(m => m.listPosition === listNo);
    if (!current)
      return 0;

    // current.Id == 0 means setup new system
    if (current.Id === 0) {
      current.Validity = true;
      if (!current.Result.OperationSucceed) // means submitted but failed!
      {
        current.Validity = false;
        return 4;
      }

      const res = this.checkComponentDateAndSMU(_typeSide, current);
      if (!this.checkComponentDateAndSMU(_typeSide, current)) {
        current.Result.LastMessage = this.Translate('SMU/HourMeter validation failed!');
        current.Result.LastMessage += this.Translate('Equipment SMU/HourMeter at setup: ') + this._currentSelection.equipment.SmuAtSetup + this.Translate(' Equipment setup date: ') + this.formatDate(this._currentSelection.equipment.SetupDate);
        current.Validity = false;
        return 2;
      }

      current.Result.LastMessage = this.Translate('Validation passed! Ready for submit');
      return 1;
    }
  }
  private formatDate(date: Date) {
    if (!date) return '-';
    date = new Date(date);
    const monthNames = [
      'January', 'February', 'March',
      'April', 'May', 'June', 'July',
      'August', 'September', 'October',
      'November', 'December'
    ];
    const day = date.getDate();
    const monthIndex = date.getMonth();
    const year = date.getFullYear();

    return day + ' ' + monthNames[monthIndex] + ' ' + year;
  }

  private dateOnly(date: Date): Date {
    if (!date) return new Date();
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }

  private dateOnlyFromUTCString(dateUTC: string): Date {
    if (!dateUTC)
      return new Date();
    if (dateUTC.indexOf('T') === -1)
      return new Date();
    const date = new Date(dateUTC);
    if (!date) return new Date();
    const result = new Date(date.getFullYear(), date.getMonth(), date.getDate());
    return result;
  }

  private getSystembyTypeSide(_typeSide: SystemTypeSide): SystemSetup {
    if (_typeSide === SystemTypeSide.LeftChain)
      return this._leftChainSetup;
    if (_typeSide === SystemTypeSide.RightChain)
      return this._rightChainSetup;
    if (_typeSide === SystemTypeSide.LeftFrame)
      return this._leftFrameSetup;
    if (_typeSide === SystemTypeSide.RightFrame)
      return this._rightFrameSetup;
    return new SystemSetup();
  }

  private getCompartTypeRemainingRequired(_typeSide: SystemTypeSide, compartTypeId: number): number {
    const _selectedComponents = this.getSystembyTypeSide(_typeSide).Components;
    const template = this._systemTemplate.find(m => m.ModelId === this._currentSelection.equipment.Model.Id && m.CompartTypeId === compartTypeId);
    const count = _selectedComponents.filter(m => m.Compart.CompartType.Id === compartTypeId).length;
    if (template) {
      return (template.Min - count > 0) ? (template.Min - count) : 0;
    }
  }

  private getCompartTypeRemainingOptional(_typeSide: SystemTypeSide, compartTypeId: number): number {
    const _selectedComponents = this.getSystembyTypeSide(_typeSide).Components;
    const template = this._systemTemplate.find(m => m.ModelId === this._currentSelection.equipment.Model.Id && m.CompartTypeId === compartTypeId);
    const count = _selectedComponents.filter(m => m.Compart.CompartType.Id === compartTypeId).length;
    if (template) {
      return (template.Max - count > 0) ? (template.Max - count) : 0;
    }
  }


  private checkComponentDateAndSMU(_typeSide: SystemTypeSide, component: ComponentSetup): boolean {
    const _currentSystem = this.getSystembyTypeSide(_typeSide);
    if (_currentSystem.InstallOnEquipment && component.EquipmentSMU < this._currentSelection.equipment.SmuAtSetup)
      return false;

    if (_currentSystem.InstallOnEquipment && component.InstallDate < this._currentSelection.equipment.SetupDate)
      return false;

    const listOrderedByDate = _currentSystem.Components.filter(m => m.listPosition !== component.listPosition).sort((a, b) => (a.InstallDate < b.InstallDate) ? 1 : -1);

    for (const c of listOrderedByDate) {
      if (c.InstallDate === component.InstallDate && component.EquipmentSMU !== c.EquipmentSMU) {// (new Date(c.InstallDate.getFullYear(), c.InstallDate.getMonth(), c.InstallDate.getDate()) == new Date(component.InstallDate.getFullYear(), component.InstallDate.getMonth(), component.InstallDate.getDate())
        // res.OperationSucceed = false;
        // res.LastMessage = this.Translate('SMU Date validation failed!') + c.listPosition + '-' + c.Compart.CompartType.Title + ' ' + this.Translate('Has the same date but different SMU!');
        return false;
      }

      if (c.InstallDate < component.InstallDate && c.EquipmentSMU > component.EquipmentSMU) {
        return false;
      }

      if (c.InstallDate > component.InstallDate && c.EquipmentSMU < component.EquipmentSMU) {

        return false;
      }
    }

    return true;
  }


  /// Decision: 1 -> Create and Install on left side
  /// Decision: 2 -> Create and Install on right side
  /// Decision: 3 -> Update Existing
  /// Decision: 4 -> Save in inventory

  submitClicked(): void {

  }


  checkComponentsForTemplate(_typeSide: SystemTypeSide): boolean {
    const modelTemplateChainList = this._setupService.getModelTemplateListForChain(this._systemTemplate);
    const modelTemplateFrameList = this._setupService.getModelTemplateListForFrame(this._systemTemplate);
    const _selectedComponents = this.getSystembyTypeSide(_typeSide).Components;
    for (const tmplt of modelTemplateChainList) {
      let count = 0;
      if (_selectedComponents && _selectedComponents.length > 0)
        count = _selectedComponents.filter(m => m.Compart.CompartType.Id === tmplt.CompartTypeId && m.Compart.Model.Id === tmplt.ModelId).length;
      if (count < tmplt.Min || count > tmplt.Max) {
        return false;
      }
    }
    return true;
  }

  canInstallOnEquipment(_sideType: SystemTypeSide): boolean {
    if (this._currentSelection.equipment.Id === 0)
      return false;
    const _currentSystem = this.getSystembyTypeSide(_sideType);
    if (this._currentSelection.equipment.Systems.filter(m => m.Side === _currentSystem.Side && m.SystemType === _currentSystem.Type).length > 0)
      return false;

    return true;
  }

  showResultMessage(item: ResultMessage): boolean {
    if (item.Id === 0 && item.OperationSucceed)
      return false;
    return true;
  }

  resultMapper(result: ResultMessage): void {
    console.log('resultMapper result -> ', result);
  }

  openSnackBar(message: string, action: string) {
    this.snackBar.open(message, action, {
      duration: 5000,
    });
  }

  // option -> 1 means copy to right
  // 2 -> means copy to all
  copySystemClicked(_typeSide: SystemTypeSide, option: number) {
    let systemArray: SystemSetup[];
    const source = this.getSystembyTypeSide(_typeSide);
    if (_typeSide === SystemTypeSide.LeftChain && option === 1)
      systemArray = [this._rightChainSetup];
    else if (_typeSide === SystemTypeSide.LeftChain && option === 2)
      systemArray = [this._rightChainSetup, this._leftFrameSetup, this._rightFrameSetup];
    else if (_typeSide === SystemTypeSide.LeftFrame && option === 1) {
      systemArray = [this._rightFrameSetup];
      this._rightFrameSetup.frameConfig = this._leftFrameSetup.frameConfig;
      this._rightFrameSetup.cannonType = this._leftFrameSetup.cannonType;
    }
    //console.log("systemArray master: ", source);
    for (const other of systemArray) {
      //console.log("systemArray other: " , other);
      other.HoursAtInstall = source.HoursAtInstall;
      other.InstallationDate = source.InstallationDate;
      other.SmuAtInstall = source.SmuAtInstall;
      other.PMUAtInstall = source.PMUAtInstall;
      other.HistoricalDistance = source.HistoricalDistance;
      other.TotalDistance = source.TotalDistance;
      // TT-1375
      if (option === 1) {
        other.BudgetLife = source.BudgetLife;
        other.BudgetDistance = source.BudgetDistance;
      }
    }
  }

  _defaultCMUsAreSet = false;


  nexStepBasic() {
    if (this.StepValidation(this._selectedIndex).OperationSucceed) {
      this.SubmitAll();
      return;
    }
  }
  nextStep() {
    //console.log("this._leftFrameSetup:", this._leftFrameSetup);
    if (this._selectedIndex === 3 && this.StepValidation(this._selectedIndex).OperationSucceed) {
      this.SubmitAll();
      return;
    }
    //!this._itIsUpdate && !this._defaultCMUsAreSet && old one TT-4559
    if (this._selectedIndex == 1 && !this.skipChainSetup) {
      //console.log("this._leftChainSetup.Components:", this._leftChainSetup.Components);
      this._leftChainSetup.Components.forEach(m => m.HoursAtInstall = this._leftChainSetup.HoursAtInstall);
      this._leftChainSetup.Components.forEach(m => m.PMUAtInstall = this._leftChainSetup.PMUAtInstall);
      this._leftChainSetup.Components.forEach(m => m.DOC = this._leftChainSetup.HistoricalDistance);
      this.updateTableView(SystemTypeSide.LeftChain);
      this._leftFrameSetup.Components.forEach(m => m.HoursAtInstall = this._leftFrameSetup.HoursAtInstall);
      this._leftFrameSetup.Components.forEach(m => m.PMUAtInstall = this._leftFrameSetup.PMUAtInstall);
      this._leftFrameSetup.Components.forEach(m => m.DOC = this._leftFrameSetup.HistoricalDistance);
      this.updateTableView(SystemTypeSide.LeftFrame);
      this._rightChainSetup.Components.forEach(m => m.HoursAtInstall = this._rightChainSetup.HoursAtInstall);
      this._rightChainSetup.Components.forEach(m => m.PMUAtInstall = this._rightChainSetup.PMUAtInstall);
      this._rightChainSetup.Components.forEach(m => m.DOC = this._rightChainSetup.HistoricalDistance);
      this.updateTableView(SystemTypeSide.RightChain);
      this._rightFrameSetup.Components.forEach(m => m.HoursAtInstall = this._rightFrameSetup.HoursAtInstall);
      this._rightFrameSetup.Components.forEach(m => m.PMUAtInstall = this._rightFrameSetup.PMUAtInstall);
      this._rightFrameSetup.Components.forEach(m => m.DOC = this._rightFrameSetup.HistoricalDistance);
      this.updateTableView(SystemTypeSide.RightFrame);

      this._defaultCMUsAreSet = true;

      this._loading++;
      //this._loadingService.finishedLoading();
    }
    //console.log("this._leftChainSetup.Components - 2 :", this._leftChainSetup.Components);
    if (this._currentSelection.equipment)
      // Adding Check InspectionCount as must me less than equal to 2 to modify undercaarriage setup
      if (this.StepValidation(this._selectedIndex).OperationSucceed && this.InspectionCount<=2) {
        if ((this.skipChainSetup && this._selectedIndex === 0) || (this.UCSetupType != 1 && this._selectedIndex === 0)) { // If the equipment application is not mining, we skip the chain step and allow it to be auto filled.
          this._selectedIndex++;
          this._selectedIndex++;
        } else
          this._selectedIndex++;
        if (this._selectedIndex === 1)
          this._lockEquipment = true;
      }

    if (this._currentSelection.equipment.EnableDistTravelledTracking && this.UCSetupType == 1)
      this._displayedColumns = ['delete', 'Component', 'Type', 'Pos', 'Brand', 'BudgetLife', 'HoursAtInstall', 'DistanceBudget', 'DOC', 'InstallCost', 'BushTurnedPercent', 'BushTurnedHours', 'MLink', 'JobNum', 'AssetNum', 'Size', 'Grouser', 'CleanerHoles'];
  }
  private systemNameStr(k: number): string {
    if (k === 1) return 'Left Chain';
    if (k === 2) return 'Right Chain';
    if (k === 3) return 'Left Frame';
    if (k === 4) return 'Right Frame';
  }
  // step -> which step needs to be validated?
  StepValidation(step: number): ResultMessage {
    const result = new ResultMessage();
    result.OperationSucceed = false;
    
    if (step === 0 && this._currentSelection.equipment.Id === 0) { // Equipment Selection
      result.LastMessage = this.Translate('Equipment is not selected!');
      return result;
    }

    if (step === 1) { // System Details
      let failed = false;

      let whichSystemFailed = 0;
      for (let k = 1; k <= 4; k++) {
        if (!this.systemSmuDateValidation(k).OperationSucceed) {
          failed = true;
          whichSystemFailed = k;
          break;
        }
        if (this._selectedSide === 3) k++; // Right systems are skipped
      }
      if (failed) {
        result.LastMessage = this.Translate(this.systemNameStr(whichSystemFailed) + ' Validation failed!');
        return result;
      }
    }

    if (step === 2) {
      if (this._selectedSide !== 3 && !this.matchComponentListsNumberType(this._leftChainSetup.Components, this._rightChainSetup.Components)) {
        result.LastMessage = this.Translate('Validation Failed! Number and type of components on the Left Chain and Right Chain need to be the same!');
        return result;
      }
      if (this._selectedSide !== 3 && !this.matchComponentListsNumberType(this._leftFrameSetup.Components, this._rightFrameSetup.Components)) {
        result.LastMessage = this.Translate('Validation Failed! Number and type of components on the Left Frame and Right Frame need to be the same!');
        return result;
      }
    }

    if (step === 2 || step === 3) {
      let systemsArray: SystemSetup[] = [];
      if (this._selectedSide === 3) // If both sides we are not validating right systems
        systemsArray = [this._leftChainSetup, this._leftFrameSetup];
      else
        systemsArray = [this._leftChainSetup, this._rightChainSetup, this._leftFrameSetup, this._rightFrameSetup];
      let p = 1;
      let failed = false;
      for (const system of systemsArray) {
        for (const component of system.Components) {
          if (!this.validateComponent(p, component).OperationSucceed) {
            failed = true;
            break;
          }
        }
        if (failed) break;
        p++;
      }
      if (failed) {
        result.LastMessage = this.Translate('Validation failed!');
        return result;
      }
    }
    result.OperationSucceed = true;
    result.LastMessage = 'Validation passed.';

    return result;
  }

  private matchComponentListsNumberType(A: ComponentSetup[], B: ComponentSetup[]): boolean {
    if (A.length !== B.length)
      return false;

    for (const T of this._setupService.getAvailableCompartTypeList()) {
      if (A.filter(m => m.Compart.CompartType.Id === T.Id).length !== B.filter(m => m.Compart.CompartType.Id === T.Id).length)
        return false;
    }
    return true;
  }

  validateComponent(_typeSide: SystemTypeSide, component: ComponentSetup): ResultMessage {
    const result: ResultMessage = new ResultMessage();
    result.OperationSucceed = false;
    const system = this.getSystembyTypeSide(_typeSide);
    if (!system) {
      result.OperationSucceed = true;
      result.LastMessage = this.Translate('System cannot be found!'); // It is not a failure for component
      return result;
    }

    /*
    let component: ComponentSetup = system.Components.find(m => m.listPosition == comp.listPosition && m.Id == comp.Id);
    if (!component) {
        result.LastMessage = this.Translate('Component not found!');
        return result;
    }
    */

    if (!component.Compart || component.Compart.Id === 0) {
      result.LastMessage = this.Translate('Validation failed: Type is not selected!');
      return result;
    }

    if (!component.Compart.CompartType || component.Compart.CompartType.Id === 0) {
      result.LastMessage = this.Translate('Validation failed: Compart Type is not selected!');
      return result;
    }

    // Unknown item added and is initially selected so no need for this validation
    /*if (component.Compart.CompartType.Id == 232) { //means component is a shoe
        if (!component.ShoeSize || component.ShoeSize.Id == 0) {
            result.LastMessage = this.Translate('Validation failed: Shoe size is not selected!');
            return result;
        }
        if (!component.Grouser || component.Grouser.Id == 0) {
            result.LastMessage = this.Translate('Validation failed: Shoe grouser is not selected!');
            return result;
        }
    }*/

    if (!component.Brand || component.Brand.Id === 0) {
      result.LastMessage = this.Translate('Validation failed: Brand is not selected!');
      return result;
    }
    result.OperationSucceed = true;
    result.LastMessage = this.Translate('Validation Passed.');
    return result;
  }

  showPosition(component: ComponentSetup): string {
    if (!component || !component.Pos || !component.Compart || !component.Compart.CompartType || !component.Compart.CompartType.Id)
      return '';
    return this._appService.getPositionString(component.Pos, component.Compart.CompartType.Id);
  }


  getFormatedDate = (currentDate) => {

    console.log("curernt ", currentDate)
    let dd = currentDate.getDate();
    let mm = currentDate.getMonth() + 1; // January is 0!
    const yyyy = currentDate.getFullYear();
    if (dd < 10) {
      dd = `0${dd}`;
    }
    if (mm < 10) {
      mm = `0${mm}`;
    }
    return `${dd} ${mm} ${yyyy}`;
  };

  stepChangedManually(event: any) {
    this._selectedIndex = event.selectedIndex;
    let backwardSteps: number = event.selectedIndex;
    let failedStep: number = event.selectedIndex;
    if (event.selectedIndex > event.previouslySelectedIndex) {
      while (backwardSteps > 0) {
        if (!this.StepValidation(backwardSteps - 1).OperationSucceed)
          failedStep = backwardSteps - 1;
        backwardSteps--;
      }
    }
    if (this._selectedIndex !== failedStep)
      setTimeout(() => { this.openSnackBar(this.Translate('Previous step validation failed!'), this.Translate('Warning')); this._selectedIndex = failedStep; }, 1000);
    else if (event.selectedIndex > event.previouslySelectedIndex && event.selectedIndex === 1)
      this._lockEquipment = true;
  }
  _submitting = false;
  private SubmitAll() {
    //console.log("Frames", this._leftFrameSetup, this._rightFrameSetup)
    let systems: SystemSetup[] = [];
    if (this._selectedSide !== 3) {
      this._leftChainSetup.InstallationDate_ = this.getFormatedDate(new Date(this._leftChainSetup.InstallationDate));
      this._rightChainSetup.InstallationDate_ = this.getFormatedDate(new Date(this._rightChainSetup.InstallationDate));
      this._leftFrameSetup.InstallationDate_ = this.getFormatedDate(new Date(this._leftFrameSetup.InstallationDate));
      this._rightFrameSetup.InstallationDate_ = this.getFormatedDate(new Date(this._rightFrameSetup.InstallationDate));
      systems = [this._leftChainSetup, this._rightChainSetup, this._leftFrameSetup, this._rightFrameSetup];
    }
    else {
      this._leftChainSetup.InstallationDate_ = this.getFormatedDate(new Date(this._leftChainSetup.InstallationDate));
      this._leftFrameSetup.InstallationDate_ = this.getFormatedDate(new Date(this._leftFrameSetup.InstallationDate));
      systems = [this._leftChainSetup, <SystemSetup>JSON.parse(JSON.stringify(this._leftChainSetup)), this._leftFrameSetup, <SystemSetup>JSON.parse(JSON.stringify(this._leftFrameSetup))];
      systems[1].Serial = this._rightChainSetup.Serial;
      systems[3].Serial = this._rightFrameSetup.Serial;
      systems[3].cannonType = this._rightFrameSetup.cannonType;
      systems[3].frameConfig = this._rightFrameSetup.frameConfig;
    }
    this._submitting = true;
    this._loading++;
    this._setupService.submit4SystemsOnEquipment(systems).subscribe(result => {
      this._submitting = false;
      for (const system of result) {
        if (system.Side === Side.Left && system.Type === SystemType.Chain) { this._leftChainSetup = system; }
        else if (system.Side === Side.Right && system.Type === SystemType.Chain) { this._rightChainSetup = system; }
        else if (system.Side === Side.Left && system.Type === SystemType.Frame) { this._leftFrameSetup = system; }
        else if (system.Side === Side.Right && system.Type === SystemType.Frame) { this._rightFrameSetup = system; }
      }
      this.showSubmitMessage();
      this.success = true;
      this._loading++;
      if (this._selectedSide === 3)
        this._selectedSide = 1;
      this._setupService.GetEquipmentSystems(this._currentSelection.equipment.Id).subscribe(res => {
        this._currentSelection.equipment.Systems = [];
        this._currentSelection.equipment.Systems.push(...res);
        this.leftchainTableDatabase.dataChange.next(this._leftChainSetup.Components);
        this.rightchainTableDatabase.dataChange.next(this._rightChainSetup.Components);
        this.leftframeTableDatabase.dataChange.next(this._leftFrameSetup.Components);
        this.rightframeTableDatabase.dataChange.next(this._rightFrameSetup.Components);
        if (this._currentSelection.equipment.Systems.length > 0)
          this._itIsUpdate = true;
        this.ref.detectChanges();
      }, error => { console.error(error); }, () => {
        this._loading--;

        if (this.UCSetupType != 1) {
          this.gottoEquipmentDetails();
        }
      });
    }, error => { console.log(error); }, () => { this._loading--; });
  }
  goToUnsynced() {
    if (this._unsyncedId && confirm(this.Translate('If you have any unsaved work in this page will be lost! Do you want to continue?')))
      // this._router.navigateByUrl('UnsyncedInspection/' + this._unsyncedId);
      //  window.open('/unsyncedinspection/' + this._unsyncedId, '_blank');
      this._pref.GetReplaceExistingTabStatus().subscribe(res => {
        if (res == "True") {
          this._router.navigate(['/unsyncedinspection', this._unsyncedId]);
        } else {
          window.open('/unsyncedinspection/' + this._unsyncedId, '_blank');

        }
      });
  }

  gottoEquipmentDetails() {
    if (this._currentSelection.equipment.Id) {
      this._inspectionsService.getUnSyncedInspection(this._unsyncedId).subscribe(result => {
        if (result.Id == 0) {
          //window.open('/equipment/' + this._currentSelection.equipment.Id, '_blank');
          //  this._router.navigate(['/equipment', this._currentSelection.equipment.Id]);

          this._pref.GetReplaceExistingTabStatus().subscribe(res => {
            if (res == "True") {
              this._router.navigate(['/equipment', this._currentSelection.equipment.Id]);
            } else {
              window.open('/equipment/' + this._currentSelection.equipment.Id, '_blank');

            }
          });
          return;
        }
        this.inspection = result;
        if (this.inspection) {
          this.SubmitMobileInspection();
        }
      })
    }

  }

  SubmitMobileInspection() {
    this._loading++;
    this._inspectionsService.submitUnsynced(this._currentSelection.equipment.Id, this._unsyncedId, this.inspection.MobileEqId).subscribe(result => {
      this._submitOperation = result;
      if (result.OperationSucceed) {
        this._notification.success(this.Translate('Sync Succeeded!'), this.Translate('Inspection saved successfully!'));
        // window.open('/equipment/' + this._currentSelection.equipment.Id, '_blank');
        this._pref.GetReplaceExistingTabStatus().subscribe(res => {
          if (res == "True") {
            this._router.navigate(['/equipment', this._currentSelection.equipment.Id]);
          } else {
            window.open('/equipment/' + this._currentSelection.equipment.Id, '_blank');

          }
        });
      } else {
        this._notification.error(this.Translate('Sync Failed!'), this.Translate(result.LastMessage));
        console.error(result.ActionLog);
      }
    }, error => { console.error(error); }, () => { this._loading--; });
  }

  showSubmitMessage() {
    const systems = [this._leftChainSetup, this._leftFrameSetup, this._rightChainSetup, this._rightFrameSetup];
    let succeeded = true;
    for (const system of systems) {
      if (!system.Result.OperationSucceed) {
        succeeded = false;
        break;
      }
      for (const component of system.Components) {
        if (!component.Result.OperationSucceed) {
          succeeded = false;
          break;
        }
      }
      if (!succeeded) break;
    }
    const countSystemSuccess = systems.filter(s => s.Result.OperationSucceed === true).length;
    if (succeeded)
      this._notification.success('Setup Complete', 'Your undercarriage was successfully setup. ');

    else if (countSystemSuccess > 0) {
      this._notification.warn('Saved Successfully', 'Please check the warning message in the page');
    } else {
      const returnedMessage = systems.filter(s => s.Result.Id === -999);
      if (returnedMessage.length > 0) {
        this._notification.error('Failed to Save', returnedMessage[0].Result.LastMessage);
      } else {
        this._notification.error('Failed to Save', 'Please check error in page to find limiting factor');
      }
    }


  }


  // todo this in a better way is server should return a more comprehensive message and status code to verify action status and display a warning accordingly
  checkIsShouldShowWarningMessage(message: string): boolean {
    if (message === 'This system is installed by replace system from inventory action and was not part of the setup!') {
      return true;
    }
    return false;
  }

  getImage(image: string) {

    return this._sanitizer.bypassSecurityTrustUrl(`data:image/*;base64,${image}`);
  }

  FamilyImage_Chain: string
  FamilyImage_Frame: string
  getFamilyDetails(value: number) {
    this._setupService.getFamilyList().subscribe(res => {
      if (res != null) {
        let familydetails = res
        familydetails.map(x => {
          if (x.type_auto == value) {
            this.FamilyImage_Chain = x.ChainImage
            this.FamilyImage_Frame = x.FrameImage
            this._allowToggleCRoller = x.AllowToggleCRoller;
          }
        })
      }
    })
  }

  getUserPref() {
    this._userPref.getUserPreferences().subscribe(res => {
      this.userUOM = res.UnitOfMeasurementName;
    });
  }

  getBushTurnedHours(element: ComponentSetup) {
    this.bushTurnedHours = element.BudgetLife * (element.BushTurnedPercent / 100);
  }

}

///Extra classes for ComponentList Table Data Source
class ComponentTableDatabase {
  dataChange: BehaviorSubject<ComponentSetup[]> = new BehaviorSubject<ComponentSetup[]>([]);
  get data(): ComponentSetup[] { return this.dataChange.value; }
  constructor(_equipmentList: ComponentSetup[]) {
    this.dataChange.next(_equipmentList);
  }
}


class ComponentDataSource extends DataSource<any> {
  constructor(private _componentDatabase: ComponentTableDatabase) {
    super();
  }

  /** Connect function called by the table to retrieve one stream containing the data to render. */
  connect(): Observable<ComponentSetup[]> {
    return this._componentDatabase.dataChange.asObservable();
  }

  disconnect() { }
}
